"use client"

import { formatCartDrawerMoney } from "../../format-money"
import styles from "./cart-drawer-summary.module.css"
import { useRouter } from "next/navigation"
import { useState } from "react"
import { flushSync } from "react-dom"
import GarantiSecurePayment from "@modules/common/components/garanti-secure-payment"
import CompanyLegalNotice from "@modules/global-shell/components/company-legal-notice"
import type { CompanyLegalDetails } from "@modules/global-shell/components/company-legal-notice/format-company-legal-copy"

export default function CartDrawerSummary({
  total,
  savingsTotal,
  currencyCode,
  pending,
  legalDetails,
}: {
  total: number
  savingsTotal: number
  currencyCode: string
  pending: boolean
  legalDetails: CompanyLegalDetails
}) {
  const router = useRouter()
  const [isNavigatingToCheckout, setIsNavigatingToCheckout] = useState(false)
  const formattedTotal = formatCartDrawerMoney(total, currencyCode)
  const formattedSavings = formatCartDrawerMoney(savingsTotal, currencyCode)

  return (
    <footer className={styles.summary} data-testid="cart-drawer-summary">
      <dl className={styles.breakdown}>
        <div className={styles.totalRow}>
          <dt>Sepet toplamı</dt>
          <dd><strong data-testid="checkout-total" className={styles.totalValue}>{formattedTotal}</strong></dd>
        </div>
        {savingsTotal > 0 ? (
          <div className={styles.savingsRow}>
            <dt>Kazancın</dt>
            <dd>{formattedSavings}</dd>
          </div>
        ) : null}
        <div className={styles.shippingRow}>
          <dt>Kargo</dt>
          <dd>Kargo ödeme adımında hesaplanır</dd>
        </div>
      </dl>

      <div className={styles.actions}>
        {pending ? (
          <button type="button" className={`${styles.checkout} ${styles.disabled}`} disabled>
            <span className={styles.checkoutContent}>Sepet güncelleniyor…</span>
          </button>
        ) : (
          <button
            type="button"
            className={styles.checkout}
            aria-label={`Ödemeye geç, sepet toplamı ${formattedTotal}`}
            aria-busy={isNavigatingToCheckout || undefined}
            disabled={isNavigatingToCheckout}
            onClick={() => {
              if (isNavigatingToCheckout) return
              flushSync(() => setIsNavigatingToCheckout(true))
              router.push("/checkout")
            }}
          >
            {isNavigatingToCheckout ? (
              <>
                <span className={styles.checkoutSpinner} data-testid="cart-drawer-checkout-spinner" aria-hidden="true" />
                <span className={styles.srOnly}>İşleniyor</span>
              </>
            ) : (
              <span className={styles.checkoutContent}>Ödemeye geç</span>
            )}
          </button>
        )}

        <div className={styles.trust} aria-label="Güvenli ödeme: Visa, Mastercard ve TROY">
          <span className={styles.trustLabel}><GarantiSecurePayment compact /></span>
          <div className={styles.badges} aria-hidden="true">
            <img src="/payment-badges/visa.svg" alt="" loading="lazy" />
            <img src="/payment-badges/mastercard.svg" alt="" loading="lazy" />
            <img src="/payment-badges/troy.png" alt="" loading="lazy" />
          </div>
        </div>
      </div>
      <CompanyLegalNotice footer={legalDetails} variant="cart" />
    </footer>
  )
}
